import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthContext } from './hooks/useAuthContext'
import { CompanyContextProvider } from './context/CompanyContext'
import { TransportProvider } from './context/TransportContext'
import { FustProvider } from "./context/FustContext";
import { LanguageProvider } from "./context/LanguageContext";

// pages & components
import Home from './pages/Home'
import Login from './pages/Login'
import Signup from './pages/Signup'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import Orderinformatie from './pages/Orderinformatie'
import Facturen from './pages/Facturen'
import OrderGoedkeuren from './pages/Ordergoedkeuren'
import Teelt from './pages/Teelt'
import Dossierteelt from './pages/Dossierteelt'
import Transport from './pages/Transport'
import Dossiertransport from './pages/Dossiertransport'
import Evaluaties from './pages/Evaluaties'
import Evaluatie from "./pages/Evaluatie";
import Beheer from './pages/Beheer'

import TransportLogin from './pages/Transport/TransportLogin'
import TransportHome from './pages/Transport/TransportHome'
import TransportFust from './pages/Transport/TransportFust'
import TransportWarehouse from './pages/Transport/TransportWarehouse'

import Navbar from './components/Navbar'
import Footer from "./components/Footer"

function App() {
  const { user } = useAuthContext()
  const cultivationCompany = user?.cultivation_company

  return (
    <div className="App">
      <BrowserRouter>
        <FustProvider>
          <TransportProvider>
            <LanguageProvider>
              <CompanyContextProvider>
                {user && <Navbar />}
                <div className="pages">
                  <Routes>
                    <Route
                      path="/"
                      element={user ? <Home /> : <Navigate to="/login" />}
                    />
                    <Route
                      path="/login"
                      element={!user ? <Login /> : <Navigate to="/" />}
                    />
                    <Route
                      path="/signup"
                      element={!user ? <Signup /> : <Navigate to="/" />}
                    />
                    <Route
                      path="/forgot-password"
                      element={!user ? <ForgotPassword /> : <Navigate to="/" />}
                    />
                    <Route
                      path="/reset-password"
                      element={!user ? <ResetPassword /> : <Navigate to="/" />}
                    />
                    <Route
                      path="/orderinformatie"
                      element={user ? <Orderinformatie /> : <Navigate to="/login" />} />
                    <Route
                      path="/facturen"
                      element={user ? <Facturen /> : <Navigate to="/login" />} />
                    <Route
                      path="/orders-goedkeuren"
                      element={user ? <OrderGoedkeuren /> : <Navigate to="/login" />} />
                    <Route
                      path="/teelt"
                      element={user ? <Teelt /> : <Navigate to="/login" />} />
                    <Route
                      path="/dossierteelt"
                      element={user ? <Dossierteelt /> : <Navigate to="/login" />} />
                    <Route
                      path="/transport"
                      element={user ? <Transport /> : <Navigate to="/login" />} />
                    <Route
                      path="/dossiertransport"
                      element={user ? <Dossiertransport /> : <Navigate to="/login" />} />
                    <Route
                      path="/evaluaties"
                      element={user ? <Evaluaties /> : <Navigate to="/login" />} />
                    <Route path="/evaluatie" element={<Evaluatie />} />
                    <Route
                      path="/beheer"
                      element={user ? <Beheer /> : <Navigate to="/login" />} />
                    <Route
                      path="/transport/login"
                      element={<TransportLogin />} />
                    <Route
                      path="/transport/home"
                      element={<TransportHome />} />
                    <Route
                      path="/transport/fust"
                      element={<TransportFust />} />
                    <Route
                      path="/transport/warehouse"
                      element={<TransportWarehouse />} />
                  </Routes>
                </div>
              </CompanyContextProvider>
            </LanguageProvider>
          </TransportProvider>
        </FustProvider>
      </BrowserRouter>
      {user && <Footer company={cultivationCompany} />}
    </div>
  );
}

export default App;
